<template>
  <div id="page_app">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-toolbar color="primary" dark dense cad>
          <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-layout column wrap>
                <v-flex lg6 sm12 xs12 pa-20>
                  <v-text-field
                    class="padr"
                    :rules="Rules"
                    required
                    label="Title"
                    name="title"
                    v-model="kategoriData.title"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Status"
                    item-text="text"
                    item-value="value"
                    v-model="kategoriData.status"
                    :items="optionStatus"
                  ></v-select>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Show"
                    item-text="text"
                    item-value="value"
                    v-model="kategoriData.showHome"
                    :items="optionShow"
                  ></v-select>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-autocomplete
                    v-model="kategoriData.menus"
                    :items="listMenu"
                    :search-input.sync="searchKategori"
                    hide-selected
                    hint="Maximum of 5 tags"
                    label="Menu"
                    multiple
                    chips
                    :rules="Rules"
                    required
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            Tidak ada hasil untuk "<strong>{{
                              searchKategori
                            }}</strong
                            >"
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex lg2 sm2 xs2>
                  <v-text-field
                    type="number"
                    label="Sort Order"
                    name="order"
                    v-model="kategoriData.sort"
                    :rules="Rules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeDialog()">Cancel</v-btn>
          <v-btn
            v-if="title === 'Tambah Kategori'"
            color="success"
            @click="saveForm({ kategoriData, opsi })"
            :disabled="
              kategoriData.title === '' ||
              kategoriData.status === '' ||
              kategoriData.showHome === '' ||
              kategoriData.sort === '' ||
              kategoriData.menus.length < 1
            "
            >Save</v-btn
          >
          <v-btn
            v-else
            color="success"
            @click="saveEdit({ kategoriData, opsi })"
            :disabled="
              kategoriData.title === '' ||
              kategoriData.status === '' ||
              kategoriData.showHome === '' ||
              kategoriData.sort === '' ||
              kategoriData.menus.length < 1
            "
            >Edit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogListMenu" persistent width="450">
      <v-card>
        <v-toolbar color="primary" dark dense cad>
          <v-toolbar-title class="subheading">Detail List Menu</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogListMenu()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="ma-3 pl-0">
          <v-chip
            v-for="item in dataListMenu"
            :key="item.id"
            class="ma-1"
            color="primary"
            text-color="white"
            label
          >
            <v-icon left> mdi-tag </v-icon>
            <b>{{ item.label }}</b>
          </v-chip>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeDialogListMenu()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mt-4">
      <v-toolbar elevation="0">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="openModal('Tambah Kategori')">
          <v-icon dark>add</v-icon>Add
        </v-btn>
        <v-btn class="ml-2" color="primary" @click.native="refresh()">
          <v-icon dark>refresh</v-icon>Refresh
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="complex.headers"
        :items="kategori.content"
        class="elevation-1"
        item-key="id"
        :loading="loading_kategori"
        :options.sync="opsi"
        :server-items-length="totaldata"
      >
        <template v-slot:progress>
          <v-skeleton-loader
            v-if="loading_kategori"
            transition="fade-transition"
            type="table-tbody"
          >
          </v-skeleton-loader>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="text-xs-left">
            <v-chip
              v-if="item.status === 1"
              color="green"
              small
              text-color="white"
              >{{ statusformat(item.status) }}</v-chip
            >
            <v-chip v-else color="red" small text-color="white">{{
              statusformat(item.status)
            }}</v-chip>
          </div>
        </template>
        <template v-slot:item.showHome="{ item }">
          <div class="text-xs-left">
            <v-chip
              v-if="item.showHome === 1"
              color="green"
              small
              text-color="white"
              >{{ showHomeformat(item.showHome) }}</v-chip
            >
            <v-chip v-else color="red" small text-color="white">{{
              showHomeformat(item.showHome)
            }}</v-chip>
          </div>
        </template>
        <template v-slot:item.menus="{ item }">
          <div class="text-xs-left">
            <v-btn
              color="primary"
              small
              @click.native="openDialogListMenu(item.listMenu)"
            >
              Detail
            </v-btn>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="text-xs-left">
            <v-btn @click.native="openFormEdit(item)" icon small>
              <v-icon color="primary" small>edit</v-icon>
            </v-btn>
            <v-btn @click.native="deleteItem(item)" icon small>
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Kategori",
  data: () => ({
    search: "",
    dialog: false,
    dialogListMenu: false,
    valid: false,
    Rules: [(v) => !!v || "Please fill input"],
    title: "",
    searchKategori: "",
    kategoriData: {
      title: "",
      status: "",
      showHome: "",
      sort: "",
      menus: [],
    },
    listMenuKategori: [],
    dataListMenu: [],
    optionStatus: [
      { text: "Enable", value: 1 },
      { text: "Disable", value: 0 },
    ],
    optionShow: [
      { text: "YES", value: 1 },
      { text: "NO", value: 0 },
    ],
    complex: {
      headers: [
        {
          text: "Title",
          value: "title",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Sort",
          value: "sort",
        },
        {
          text: "Show Home",
          value: "showHome",
        },
        {
          text: "List Menu",
          value: "menus",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    },
    opsi: {
      search: "",
      itemsPerPage: 10,
      page: 1,
      sortBy: ["asc"],
    },
    opsiMenu: {
      search: "",
      itemsPerPage: 1000,
      page: 1,
      sortBy: ["id"],
    },
  }),
//   mounted() {
//     this.getKategori(this.opsi);
//   },
  watch: {
    opsi: {
      handler() {
        this.getKategori(this.opsi);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("Kategori", [
      "loading_kategori",
      "kategori",
      "listMenu",
      "totaldata",
    ]),
  },
  methods: {
    ...mapActions({
      getKategori: "Kategori/getKategori",
      Add: "Kategori/Add",
      getMenuApps: "Kategori/getMenuOnKategori",
      Delete: "Kategori/Delete",
      Edit: "Kategori/Edit",
    }),
    refresh() {
      (this.opsi = {
        search: "",
        itemsPerPage: 10,
        page: 1,
        sortBy: ["asc"],
      }),
        this.getKategori(this.opsi);
    },
    async openFormEdit(data) {
      this.title = "Edit Kategori";
      this.getMenuApps(this.opsiMenu);
      let menuData = []
      data.listMenu.forEach(element => {
          menuData.push(element.id)
      });
      let dataKategori = {
          "id": data.id,
        "title": data.title,
        "status": data.status,
        "showHome": data.showHome,
        "sort": data.sort,
        "menus": menuData
        }
      this.kategoriData = dataKategori;
      console.log(dataKategori);
      this.dialog = true;
    },
    openModal(title) {
      this.kategoriData = {
        title: "",
        status: "",
        showHome: "",
        sort: "",
        menus: [],
      };
      this.getMenuApps(this.opsiMenu);
      this.title = title;
      this.dialog = true;
    },
    openDialogListMenu(data) {
      this.dialogListMenu = true;
      this.dataListMenu = data
    },
    closeDialogListMenu() {
        this.dialogListMenu = false;
      this.dataListMenu = []
    },
    closeDialog() {
      this.title = "";
      this.kategoriData = {
        title: "",
        status: "",
        showHome: "",
        sort: "",
        menu: [],
      };
      this.dialog = false;
    },
    async saveForm(data) {
      console.log(data);
      await this.Add(data);
      this.closeDialog();
    },
    async saveEdit(data){
        console.log(data);
        await this.Edit(data)
        this.closeDialog();
    },
    deleteItem(data) {
      if (confirm("Are you sure you want delete ?")) {
        this.Delete({ id: data.id, opsi: this.opsi });
      }
    },
    statusformat (value) {
      let a = 'Disable'
      if (value === 1) {
        a = 'Enable'
      }
      return a
    },
    showHomeformat (value) {
      let a = 'NO'
      if (value === 1) {
        a = 'YES'
      }
      return a
    },
  },
};
</script>

<style lang="stylus" scoped>
.irma-image-priview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 150px;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 4px #ccc;
  box-shadow: 0 0 4px #ccc;
}

.imgupload-mask {
  width: 100%;
  max-width: 180px;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.iconupload {
  position: absolute;
  top: 0;
}

.quill {
  height: 300px;
  padding-bottom: 95px;
}

.imgslidelist {
  width: 32px;
  height: 32px;
}

.tdlist {
  padding: 4px !important;
}

.padr {
  padding-right: 10px !important;
}

.tdr {
  padding-left: 30px !important;
}
</style>